import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const RequestPushMsg = (token, data) => {
    const {
        config
    } = firebase;
    
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    // let url = `${host}/send_notification`;
   let url = `https://us-central1-${config.projectId}.cloudfunctions.net/send_notification`
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
    .then((response) => {
     console.log('response:', response);
    })
    .catch((error) => {
        console.log(error)
    });
}

export const savePushMessage = (data) => {
    const { config } = firebase;
    console.log('data:', data);
   let url = `https://us-central1-${config.projectId}.cloudfunctions.net/send_web_notification`
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            ...data
        })
    })
    .then((response) => {
     console.log('response:', response);
    })
    .catch((error) => {
        console.log('savePushMessage error:', error)
    });
}